var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"eye-container"},[_c('div',{staticClass:"blinking-eye pointer",on:{"click":_vm.showContent}})]),(_vm.showFlag)?_c('AIHelper'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }